export default "https://cdn-static.gokick.com/assets/3759ced803c9aed0ddbd8c13c713c33e7dde05d8/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";